import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HistoriqueLogComponent } from './historique-log/historique-log.component';
import { AudienceComponent } from './audience/audience.component';
import { ExtractionParProfilComponent } from './extraction-par-profil/extraction-par-profil.component';
import { ExtractionComponent } from './extraction/extraction.component';
import { ExtractionParticulierComponent } from './extraction-particulier/extraction-particulier.component';
import { ExtractionCorporateComponent } from './extraction-corporate/extraction-corporate.component';
import { ExtractionProfessionnelComponent } from './extraction-professionnel/extraction-professionnel.component';
import { ExtractionProductProgramComponent } from './extraction-product-program/extraction-product-program.component';
import { ExtractionDirectionComponent } from './extraction-direction/extraction-direction.component';

const routes: Routes = [
  
  {
    path: '',
    data: {breadcrumb: 'Reporting'},
    children: [
      
      {
        path:'',
        redirectTo: 'historique-log',
        pathMatch: 'full' 
      },
      {
        path: 'historique-log',
        component: HistoriqueLogComponent,
        data: {breadcrumb: 'Historique log'},
      },
      {
        path: 'audience',
        component: AudienceComponent,
        data: {breadcrumb: 'Audience'},
      },
      { 
        path: 'profile', 
        component: ExtractionParProfilComponent,
        data: {breadcrumb: 'Profil'}
      },
      { 
        path: 'dossier', 
        component: ExtractionComponent,
        data: {breadcrumb: 'Dossiers'}
      },
      { 
        path: 'dossier-particulier', 
        component: ExtractionParticulierComponent,
        data: {breadcrumb: 'Dossiers particulier'}
      },
      { 
        path: 'dossier-corporate', 
        component: ExtractionCorporateComponent,
        data: {breadcrumb: 'Dossiers corporate'}
      },
      { 
        path: 'dossier-professionnel', 
        component: ExtractionProfessionnelComponent,
        data: {breadcrumb: 'Dossiers professionnel'}
      },
      { 
        path: 'dossier-product-program', 
        component: ExtractionProductProgramComponent,
        data: {breadcrumb: 'Dossiers product program'}
      },
      { 
        path: 'direction', 
        component: ExtractionDirectionComponent,
        data: {breadcrumb: 'Direction'}
      },

    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportingRoutingModule { }